import styled from 'styled-components';

export const SimulatorWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing.m};
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1);
`;

export const SimulatorTitle = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const ButtonContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.s};
`;

export const SimulatorDataContainer = styled.div`
  display: flex;
  align-items: flex-start;

  & .donut-circle-bg {
    stroke-width: 7;
    stroke: ${({ theme }) => theme.colorsInObjects.gray[600]};
  }

  & .donut-circle-value {
    stroke-width: 7;
  }
  & .donut-circle-change {
    stroke-width: 7;
  }
`;

export const SimulatorInfosContainer = styled.div`
  margin-left: ${({ theme }) => theme.spacing.md};
`;

export const InfoTitleContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.s};
`;

export const MessageContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.m};
`;

export const ResetButtonContainer = styled.div`
width: 120px;
`;
